import axios from 'axios'
// axios.defaults.headers.post['Content-Type'] = 'application/json';
const BASE_URL = process.env.VUE_APP_BASE_API
// 创建axios实例
const request = axios.create({
  baseURL: BASE_URL,
  // withCredentials:true, //yunxuxiedaicookie
  timeout: 50000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
})
// axios 请求拦截器
request.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    return Promise.error(error);
  }
);


//ajax返回请求拦截 拦截
request.interceptors.response.use(
  response=> {
    // ajax 返回状态
    const res = response.data
    
    // 状态不为200的时候
    if (!res.features && res.code !== 200 ) {
      return res
    } else {
      if (data.status) {
        return res
      } else {
        if (!res.data) return 'null'
        return res.data
      }
    }
  },
  
  error => {
    const errMsg = error.toString()
    const code = errMsg.substr(errMsg.indexOf('code') + 5)
    
    if (parseInt(code) === 401) {
      console.log(error)
    }
    return Promise.reject(error)
  }
)

export default request
